import { useNavigate } from 'react-router-dom';

export const useNavigateWithSecureParams = () => {
  const routerDomNavigate = useNavigate();

  const setParam = (key: string, value: any) => {
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  };

  const removeParam = (key: string) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  };

  const clearParams = () => {
    sessionStorage.clear();
    localStorage.clear();
  };

  const getParam = (key: string) => {
    return sessionStorage.getItem(key) ?? localStorage.getItem(key);
  };

  const navigate = (
    path: string,
    options?: {
      secureParams?: Record<string, any>;
      paramsToClear?: string[];
    }
  ) => {
    const { secureParams, paramsToClear = [] } = options || {};

    if (paramsToClear.length > 0) {
      paramsToClear.forEach((key) => {
        removeParam(key);
      });
    }

    if (secureParams) {
      Object.keys(secureParams).forEach((key) => {
        if (secureParams[key] !== undefined && secureParams[key] !== null && secureParams[key] !== '') {
          setParam(key, secureParams[key]);
        } else {
          removeParam(key);
        }
      });
    }

    routerDomNavigate(path);
  };

  return { navigate, getParam, setParam, removeParam, clearParams };
};
